module.exports = "<p>\n  provider-preferences works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/provider/provider-preferences.component.html
// module id = ./src/app/views/provider/provider-preferences.component.html
// module chunks = main